import { FC } from 'react';
import cn from 'classnames';
import { Popconfirm, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { ToolbarRenderInfoType } from 'rc-image/lib/Preview';

import {
  DownloadOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomOutOutlined,
  ZoomInOutlined,
} from '@ant-design/icons';
import TrashSecondaryIcon from '@/comp/common/icons/TrashSecondaryIcon';

import { StyledToolbar } from './ImagePreviewToolbar.styles';
import { downloadImage } from './ImagePreviewToolbar.utils';

type Props = ToolbarRenderInfoType & {
  image: {
    name: string;
  };
  onDelete?: () => void;
  disabled?: boolean;
};

const { useToken } = theme;

export const ImagePreviewToolbar: FC<Props> = ({ transform, actions, image, onDelete, disabled }) => {
  const { token } = useToken();
  const { t } = useTranslation();
  const disabledDelete = disabled || !onDelete;

  const handleDownload = () => downloadImage(image.url, image.name, t);

  return (
    <StyledToolbar size={12} className="toolbar-wrapper">
      <DownloadOutlined disabled={!image.url} onClick={handleDownload} />
      <Popconfirm
        title={t('deleteImage')}
        onConfirm={onDelete}
        okText={t('ok')}
        cancelText={t('cancel')}
        disabled={disabledDelete}
        zIndex={1203}
      >
        <TrashSecondaryIcon
          disabled={disabledDelete}
          height={22}
          width={23}
          className={cn('trash-icon', disabledDelete && 'cursor-not-allowed')}
          color={token['previewOperationColor']}
          disabledColor={token['previewOperationColorDisabled']}
        />
      </Popconfirm>
      <RotateLeftOutlined onClick={actions.onRotateLeft} />
      <RotateRightOutlined onClick={actions.onRotateRight} />
      <ZoomOutOutlined disabled={transform.scale === 1} onClick={actions.onZoomOut} />
      <ZoomInOutlined disabled={transform.scale === 50} onClick={actions.onZoomIn} />
    </StyledToolbar>
  );
};
